import { Navigate } from "react-router-dom";
import { useDraft } from "../../../shared/context/DraftContext.js";
import { coursePath, useCourseSlug } from "../../../shared/lib/coursePath.js";
import { NoDraft } from "../../draft/components/NoDraft.js";
import styles from "../../../shared/components/shell.module.css";

/**
 * `/lehrgaenge/:slug/lektionen` ohne gewählte Lektion.
 *
 * Es führt zur ersten, statt eine leere Fläche mit „wählen Sie links etwas“ zu
 * zeigen: der Lehrgang beginnt bei Lektion 1, und wer etwas anderes will, sieht
 * die Liste ja daneben. Nur wenn es noch keine einzige Lektion gibt, ist der
 * Hinweis auf den Assistenten die einzige sinnvolle Auskunft.
 */
export function FirstLesson() {
  const slug = useCourseSlug();
  const { bundle } = useDraft();
  if (!bundle) return <NoDraft />;

  const first = bundle.lessons[0];
  if (first) return <Navigate to={coursePath(slug, `lektionen/${first.key}`)} replace />;

  return (
    <div className={styles.card}>
      <h1 className={styles.title}>Noch keine Lektion</h1>
      <p className={styles.subtitle}>
        Der Lehrgang ist leer. „Neue Lektion“ links führt durch das Anlegen.
      </p>
    </div>
  );
}
